export const addres = {
    client: '/client',
    operator: '/operator',
    statusInfo: '/status-info',
    agentInfo: '/agent-info',
    page404: '/404',
};
